import React from 'react';
import { Check, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useFamilyStore } from '@/store/familyStore';
import { AddRequest } from '@/types';
import { getAncestorLineage } from '@/utils/family/ancestors';
import { format, parseISO } from 'date-fns';
import { ar } from 'date-fns/locale';

interface RequestListProps {
  requests: AddRequest[];
  isAdmin: boolean;
  onReview: (request: AddRequest) => void;
  onReject: (requestId: string) => void;
}

export function RequestList({ requests = [], isAdmin, onReview, onReject }: RequestListProps) {
  const { members } = useFamilyStore();

  

  if (!requests?.length) {
    return (
      <p className="p-4 text-center text-gray-500">
        لا توجد طلبات معلقة
      </p>
    );
  }



  return (
    <div className="bg-white shadow-sm rounded-lg divide-y">
      {requests.map((request) => {
        const parent = members.find(m => m.id === request.parent_id);
        const parentLineage = parent ? getAncestorLineage(parent.id, members) : 'غير محدد';
        
        return (
          <div key={request.id} className="p-4">
            <div className="flex items-start justify-between">
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <span className="text-xs bg-primary/10 text-primary px-2 py-1 rounded-full">
                    إضافة مولود
                  </span>
                  <span className={`text-xs px-2 py-1 rounded-lg ${
                    request.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                    request.status === 'approved' ? 'bg-green-100 text-green-800' :
                    'bg-red-100 text-red-800'
                  }`}>
                    {request.status === 'pending' ? 'قيد المراجعة' :
                     request.status === 'approved' ? 'تمت الموافقة' : 'مرفوض'}
                  </span>
                </div>

                <div className="text-sm text-gray-600 space-y-1">
                  <p>
                    <span className="font-medium ml-1">مقدم الطلب:</span>
                    {request.requester_name}
                  </p>
                  <p>
                    <span className="font-medium ml-1">اسم المولود:</span>
                    {request.child_name}
                  </p>
                  <p>
                    <span className="font-medium ml-1">رقم الهاتف:</span>
                    <span dir="ltr" className="font-mono">{request.phone_number}</span>
                  </p>
                  <p>
                    <span className="font-medium ml-1">الأب:</span>
                    {parentLineage}
                  </p>
                  <p className="text-xs text-gray-500">
                    {format(parseISO(request.created_at), 'PPpp', { locale: ar })}
                  </p>
                </div>
              </div>

              {request.status === 'pending' && isAdmin && (
                <div className="flex gap-2">
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => onReview(request)}
                    className="text-green-600 hover:text-green-700 hover:bg-green-50"
                    title="مراجعة الطلب"
                  >
                    <Check className="h-4 w-4" />
                  </Button>
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => onReject(request.id)}
                    className="text-red-600 hover:text-red-700 hover:bg-red-50"
                    title="رفض الطلب"
                  >
                    <X className="h-4 w-4" />
                  </Button>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}